import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    form: {
        marginTop: "16px",
        marginBottom: "66px",
    },
    content: {
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
    },
}));

